import { PRIMARY, SECONDARY, makeThemeColor } from '@tornado-rdk/theme';

export const HEIGHT = 4;

export const colors = {
  background: makeThemeColor(PRIMARY, 0.3),
  bar: makeThemeColor(SECONDARY),
};
